// extracted by mini-css-extract-plugin
export default {"PropertySpyList_ItemName":"PropertySpySelectorContainer_PropertySpyList_ItemName__fkaCf","PropertySpyList_Item":"PropertySpySelectorContainer_PropertySpyList_Item__QqMGM"};